<template>
  <div v-if="pinnedOrdersInOrders.length > 0" class="avecor-table" style="position:fixed; bottom:0px; z-index:100; background:#2A2A2A; border-top:1px solid #FFF;width:100%;display:flex;height:20px;color:#FFF;">
    <!-- TABLE --->
    <div v-for="o in orderArray" :key="o.id + '_pinned_in_order'" style="flex:1;text-align:center;max-width:300px;border-right:1px solid #ccc;line-height:18px;cursor:pointer;" @click="selectedOrderIdInOrders = o.id">
      <div :style="o.id === selectedOrderIdInOrders ? 'background:#CACACA;color:#000' : ''">
        <span style="font-size:9px;">{{o.text}}</span>
        <i class="fas fa-times-circle ml-2" style="font-size:10px;" @click.stop="removeFromPinned(o.id)"></i>
      </div>
    </div>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'

export default {
    props: ["location"],
    created () {
    },
    mounted() {
      
    },
    data: () => ({
      showArchived:true,
      isAllNew:true
    }),
    computed: {
      selectedOrderId:{
        get: function () {
          if(this.location === 'orders') return this.selectedOrderIdInOrders
          else if(this.location === 'margins') return this.selectedOrderIdInMargins
          else if(this.location === 'stock') return this.selectedOrderIdInStock
        },
        set: function (newValue) {
          if(this.location === 'orders') this.selectedOrderIdInOrders = newValue
          else if(this.location === 'margins') this.selectedOrderIdInMargins = newValue
          else if(this.location === 'stock') this.selectedOrderIdInStock = newValue
        }
      },
      orderArray(){
        var ids = []
        Object.keys(this.orders).forEach(oId => {
          if (this.pinnedOrdersInOrders.includes(oId)) {
            var o = this.orders[oId]
            ids.push({orderId:oId, companyId : o.companyId, created_at:o.created_at, salesperson:o.salesperson})
          }
        })
        var orderDetails = {}
        ids.forEach(idg => {
          var text = ''
          var companyName = this.companies[idg.companyId] ? this.companies[idg.companyId].companyName : ''
          if (companyName.length > 25) companyName = companyName.substr(0,25)+'...'
          var salesperson = this.staff[idg.salesperson].firstName
          var date = this.customFormatter(idg.created_at)
          text = date + ' - ' + salesperson + ' - ' + companyName
          orderDetails[idg.orderId] = {id:idg.orderId,text}
        })
        var orderArray = []
        this.pinnedOrdersInOrders.forEach(oId => {
          if(orderDetails[oId]) orderArray.push(orderDetails[oId])
        })
        
        return orderArray
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      ...mapFields({
        reserved:"reserved",
        pricingVariables:"pricingVariables.pricingVariables",
        isSyncOrderToNetvisorActive:"isSyncOrderToNetvisorActive",
        device:"device",
        settings:"settings",
        companies:"company.companies",
        orders:"order.orders",
        staff:"staff.staff",
        user:"user",
        productVariations:"productVariation.productVariations",
        //selectedOrderCompanyId:"views.orders.selectedOrder.companyId",
        pinnedOrdersInOrders:"views.orders.pinnedOrders",
        selectedOrderIdInOrders:"views.orders.selectedOrder.orderId",
        selectedOrderIdInMargins:"views.margins.selectedOrder.orderId",
        selectedOrderIdInStock:"views.stock.selectedOrder.orderId",
      }),
    },

    watch: {
    },
    methods: {
      removeFromPinned(oId){
        this.pinnedOrdersInOrders = this.pinnedOrdersInOrders.filter(o => o !== oId)
      },
      customFormatter(date,full) {
        if(!date) return ''
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          if(full) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          if(full) return dateFormat(date, "yyyy-mm-dd HH:MM")
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      copy (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
    },
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/PinnedOrders.vue